import React from 'react';

import { hasBeekeeperFormsAccess } from '@lumapps/forms/ducks/selectors';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiFileDocumentEdit } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import { formsRoute } from '../../routes';

export const FormsSideNavigation = (props: Partial<SideNavigationItemProps>) => {
    const isAllowed = useSelector(hasBeekeeperFormsAccess);
    const { translateKey } = useTranslate();

    if (isAllowed) {
        return (
            <SideNavigationItem
                {...props}
                route={formsRoute}
                label={translateKey(GLOBAL.FORMS)}
                icon={mdiFileDocumentEdit}
            />
        );
    }

    return null;
};

FormsSideNavigation.displayName = 'SideNavigationItem';
